import { RegistrationActions } from '../actions/registration-actions';
import { AppThunk } from '../actions';
import * as ApiRequests from '../../api/requests';
import { HttpRequest } from '../../api/http-request';
import { AuthHelper } from '../../types';

export const RegistrationThunks = {
    loadEULA: (language: string): AppThunk => async (dispatch): Promise<void> => {
        dispatch(RegistrationActions.loadEulaStarted(language));

        // TODO: No decision has been made about where the EULA content will come from.
        //       For now we'll just pull content from the public directory of the React web app.
        const url = '/EULA.txt';

        const payload = await HttpRequest.get<string>({
            resource: url,
            prependApiUrl: process.env.NODE_ENV === 'test', // In acceptance tests this needs to come from the API server (there is no other web server to provide the static content in tests)
            responseType: 'text',
            headers: {
                language,
            },
        });

        if (payload.status === 200) {
            dispatch(RegistrationActions.loadEulaSucceeded(payload.response));

            return;
        }

        dispatch(RegistrationActions.loadEulaFailed());
    },

    validateUserRegistrationRequest: (validationcode: string): AppThunk => async (dispatch): Promise<void> => {
        dispatch(RegistrationActions.validateUserRegistrationStarted());

        const payload = await ApiRequests.validateUserRegistrationRequest(
            { validationcode },
            { authHelper: undefined }
        );

        if (payload.ok) {
            dispatch(
                RegistrationActions.validateUserRegistrationSucceeded(
                    payload.response.data.fname,
                    payload.response.data.lname,
                    payload.response.data.phone
                )
            );

            return;
        }

        dispatch(
            RegistrationActions.validateUserRegistrationFailed(
                `${ApiRequests.extractResponseNotOkCode(payload.response)}`
            )
        );
    },

    completeRegistration: (
        userData: {
            firstName: string;
            lastName: string;
            phoneNumber: string;
            email: string;
            password?: string;
            countryCode?: string;
        },
        validationcode: string
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(RegistrationActions.registerUserStarted());
        const payload = await ApiRequests.registerUser(
            {
                validationcode,
                firstname: userData.firstName,
                lastname: userData.lastName,
                phone: userData.phoneNumber !== '' ? `${userData.countryCode}${userData.phoneNumber}` : '',
                password: userData.password,
            },
            { authHelper: undefined }
        );

        if (payload.ok) {
            dispatch(
                RegistrationActions.registerUserSucceeded(
                    payload.response.data.email,
                    payload.response.data.organizationName
                )
            );

            return;
        }

        const erroCode = ApiRequests.extractResponseNotOkCode(payload.response);
        dispatch(RegistrationActions.registerUserFailed(erroCode.toString()));
    },

    inviteUserRegistration: (
        email: string,
        roleLocationList: Array<{ roleId: string; siteIds: string[] }>,
        addToast: Function
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(RegistrationActions.inviteUserStarted());

        const payload = await ApiRequests.requestUserRegistration(
            {
                user: email,
                role: roleLocationList,
            },
            { authHelper: undefined }
        );

        if (payload.ok) {
            dispatch(RegistrationActions.inviteUserSucceeded());

            return;
        }
        const errorCode = ApiRequests.extractResponseNotOkCode(payload.response);
        const errorMessage = ApiRequests.extractErrorCodeWithMessage(payload.response);
        // **  Error code coming from server side :"User already registered for given organization, failed to send invitation"
        if (errorCode !== 3007 && errorCode !== 9007)
            addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
        dispatch(RegistrationActions.inviteUserFailed(errorMessage));
    },

    deleteUser: (userId: string, siteIds: string[], addToast: Function, authHelper: AuthHelper): AppThunk => async (
        dispatch
    ): Promise<void> => {
        dispatch(RegistrationActions.deleteUserStarted());

        const payload = await ApiRequests.userDelete(
            {
                users: [{ userId: userId, siteIds: siteIds }],
            },
            { authHelper }
        );

        if (payload.ok) {
            dispatch(RegistrationActions.deleteUserSucceeded());

            return;
        }
        addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
        dispatch(RegistrationActions.delteUserFailed(`${ApiRequests.extractResponseNotOkCode(payload.response)}`));
    },
};
